import React from 'react'

import { withMicrocopy } from '~contexts/MicrocopyContext'

import LogInOutButton from './LogInOutButton'
import CloseButton from './CloseButton'
import Username from './Username'
import RunButton from './RunButton'
import ActiveEndpoint from './ActiveEndpoint'
import Intro from './Intro'

import style from './Control.module.scss'

const Control = ({
  explorer,
  microcopy
}) => (
  <>
    { explorer && (
      <div 
        className={style.bar}
        data-display={explorer.enabled}
      >
        <ActiveEndpoint explorer={explorer} />
        <Intro microcopy={microcopy} />
        <CloseButton explorer={explorer} microcopy={microcopy}  />
        <RunButton explorer={explorer} microcopy={microcopy} />
        <LogInOutButton explorer={explorer} microcopy={microcopy} />
        <Username explorer={explorer} />
      </div>
    )}
  </>
)

export default withMicrocopy(Control)
